
import { useState } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Anh Minh Tuấn',
      location: 'Hà Nội',
      tour: 'Tour 3 Đảo - Tháng 6/2024',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/8d70233f91e867b2b9ce5c22716d5ca5.jpg',
      comment: 'Chuyến đi tuyệt vời nhất từ trước đến nay! Cảnh đẹp Hawaii không thể tin được, đặc biệt là cung đường Hana và núi lửa. Đội ngũ hỗ trợ rất nhiệt tình, lái xe dễ dàng hơn tôi nghĩ. Gia đình tôi đã có những kỷ niệm không thể quên!'
    },
    {
      name: 'Chị Lan Anh',
      location: 'TP. Hồ Chí Minh',
      tour: 'Tour 2 Đảo - Tháng 8/2024',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20Vietnamese%20female%20tourist%20in%20her%2030s%20wearing%20summer%20dress%2C%20smiling%20warmly%2C%20tropical%20Hawaii%20beach%20background%2C%20professional%20photography%2C%20simple%20background&width=400&height=400&seq=customer-2&orientation=squarish',
      comment: 'Tour được tổ chức rất chuyên nghiệp. Khách sạn đẹp, lịch trình hợp lý, không bị gấp gáp. Show Polynesian rất đặc sắc, Trân Châu Cảng đầy cảm xúc. Giá tour hợp lý so với những gì được trải nghiệm. Rất đáng tiền!'
    },
    {
      name: 'Anh Đức Thắng',
      location: 'Đà Nẵng',
      tour: 'Tour 3 Đảo - Tháng 9/2024',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20Vietnamese%20male%20tourist%20in%20his%2035s%20wearing%20Hawaiian%20shirt%2C%20smiling%20broadly%2C%20tropical%20scenery%20background%2C%20professional%20photography%2C%20simple%20background&width=400&height=400&seq=customer-3&orientation=squarish',
      comment: 'Lái xe tự khám phá Hawaii là trải nghiệm tuyệt vời! Tự do, linh hoạt, được dừng chân bất cứ đâu muốn. Núi lửa Đảo Lớn thật choáng ngợng, dung nham đỏ rực trong đêm không thể diễn tả bằng lời. Nhóm trưởng hỗ trợ rất tốt!'
    },
    {
      name: 'Chị Thu Hương',
      location: 'Hải Phòng',
      tour: 'Tour 2 Đảo - Tháng 10/2024',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20Vietnamese%20female%20tourist%20in%20her%2040s%20wearing%20sunglasses%20and%20summer%20outfit%2C%20smiling%20joyfully%2C%20tropical%20Hawaii%20background%2C%20professional%20photography%2C%20simple%20background&width=400&height=400&seq=customer-4&orientation=squarish',
      comment: 'Dịch vụ tuyệt vời từ A-Z! Từ tư vấn visa, chuẩn bị hồ sơ đến hỗ trợ trong suốt hành trình. Vịnh Hanauma đẹp như tranh, lặn ngắm san hô và rùa biển rất thú vị. Cả nhóm đều rất hài lòng và muốn quay lại!'
    },
    {
      name: 'Anh Hoàng Nam',
      location: 'Cần Thơ',
      tour: 'Tour 3 Đảo - Tháng 11/2024',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20Vietnamese%20male%20tourist%20in%20his%2045s%20wearing%20polo%20shirt%2C%20smiling%20warmly%2C%20tropical%20beach%20background%2C%20professional%20photography%2C%20simple%20background&width=400&height=400&seq=customer-5&orientation=squarish',
      comment: 'Tour 3 đảo rất đáng để trải nghiệm! Mỗi đảo có nét đẹp riêng. Maui lãng mạn với Hana Road, Đảo Lớn hùng vĩ với núi lửa, Oahu sôi động với Waikiki. Ăn uống ngon, khách sạn tốt. Đội ngũ Việt tại Mỹ hỗ trợ rất tận tình!'
    },
    {
      name: 'Chị Mai Phương',
      location: 'Nha Trang',
      tour: 'Tour 2 Đảo - Tháng 12/2024',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20Vietnamese%20female%20tourist%20in%20her%2035s%20wearing%20casual%20summer%20clothes%2C%20smiling%20brightly%2C%20tropical%20scenery%20background%2C%20professional%20photography%2C%20simple%20background&width=400&height=400&seq=customer-6&orientation=squarish',
      comment: 'Chuyến đi ý nghĩa với gia đình! Con cái rất thích lặn biển và xem show văn hóa. Trân Châu Cảng là bài học lịch sử sống động. Giá tour hợp lý, dịch vụ chuyên nghiệp. Cảm ơn đội ngũ đã tạo nên kỷ niệm đẹp cho gia đình tôi!'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Cảm nhận <span className="text-blue-600">khách hàng</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hàng nghìn khách hàng đã trải nghiệm và hài lòng với tour Hawaii của chúng tôi
          </p>
        </div>

        {/* Testimonial Carousel */}
        <div className="relative max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 p-8 lg:p-12">
              {/* Customer Image */}
              <div className="lg:col-span-2 flex flex-col items-center justify-center">
                <div className="relative w-48 h-48 rounded-full overflow-hidden shadow-xl mb-4">
                  <img
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-1">
                  {testimonials[currentIndex].name}
                </h3>
                <p className="text-gray-600 mb-2">{testimonials[currentIndex].location}</p>
                <p className="text-sm text-blue-600 font-semibold mb-3">
                  {testimonials[currentIndex].tour}
                </p>
                {/* Rating */}
                <div className="flex gap-1">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
              </div>

              {/* Testimonial Content */}
              <div className="lg:col-span-3 flex flex-col justify-center">
                <i className="ri-double-quotes-l text-6xl text-blue-200 mb-4"></i>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                  {testimonials[currentIndex].comment}
                </p>
                <i className="ri-double-quotes-r text-6xl text-blue-200 self-end"></i>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-16 w-12 h-12 bg-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center hover:scale-110 cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-line text-2xl text-blue-600"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-16 w-12 h-12 bg-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center hover:scale-110 cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-line text-2xl text-blue-600"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex
                    ? 'bg-blue-600 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#final-cta"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-teal-500 text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Xem thêm cảm nhận khách hàng
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
